import { FeatureCollection } from 'geojson';

import { SnBaseLayer } from './base-layer';
import { SnLayerType } from './layer-type';

export class SnInternalLayer extends SnBaseLayer {
  public readonly type = SnLayerType.Internal;

  public toGeoJSON(): FeatureCollection {
    return {
      type: 'FeatureCollection',
      features: this.objects.map((object) => object.toGeoJSON()),
    };
  }
}
